module.exports = __webpack_public_path__ + "static/media/leggje_samman.caed035e.m4a";